import { Slice } from './types'
import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

const getSlice = (state: any): Slice => {
  return state.quote.placeOrder
}

export const getPlaceOrder = (cartId: CartId) => (state: RootState) => {
  const slice = getSlice(state)
  return slice[cartId ?? ''] ?? {}
}

export const getOrderId = (cartId: CartId) => (state: RootState) => {
  const order = getPlaceOrder(cartId)(state)
  const incrementalId = getIncrementalId(cartId)(state)
  return order.payload?.increment_id ?? incrementalId
}

export const getIncrementalId = (cartId: CartId) => (state: RootState): string => {
  const order = getPlaceOrder(cartId)(state)
  const incrementalId = order.payload as unknown as string
  return incrementalId
}

export const getErrorMessage = (cartId: CartId) => (state: RootState) => {
  const order = getPlaceOrder(cartId)(state)
  const { isFailure, payload } = order ?? {}
  if (isFailure) {
    const message = payload?.message
    return message
  }
}
